import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const TemplateCreateGraphic = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox={true}>
      <svg
        {...props}
        viewBox="0 0 260 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5054_4642)">
          <rect width="260" height="120" fill="#F5F7F7" />
          <g filter="url(#filter0_dd_5054_4642)">
            <rect
              x="30.2502"
              y="25.0499"
              width="93.6"
              height="75.6"
              rx="1.8"
              fill="#DFE3E3"
            />
            <g clipPath="url(#clip1_5054_4642)">
              <rect
                x="27.5503"
                y="22.35"
                width="93.6"
                height="75.6"
                rx="3.6"
                fill="white"
              />
              <path
                d="M27.5503 25.95C27.5503 23.9617 29.1621 22.35 31.1503 22.35H117.55C119.539 22.35 121.15 23.9618 121.15 25.95V30.45H27.5503V25.95Z"
                fill="#EFF1F1"
              />
              <circle cx="32.9503" cy="26.85" r="1.35" fill="#C9CDCD" />
              <circle cx="37.9005" cy="26.85" r="1.35" fill="#C9CDCD" />
              <circle cx="42.8505" cy="26.85" r="1.35" fill="#C9CDCD" />
              <rect
                x="36.5503"
                y="42.15"
                width="75.6"
                height="18"
                rx="1.8"
                fill="#D9E4FB"
              />
              <rect
                x="36.5503"
                y="65.5499"
                width="34.2"
                height="21.6"
                rx="1.8"
                fill="#EAF0FF"
              />
              <rect
                x="76.1504"
                y="67.35"
                width="34.2"
                height="3.6"
                rx="1.8"
                fill="#C9D7FB"
              />
              <rect
                x="76.1504"
                y="74.5499"
                width="25.2"
                height="3.6"
                rx="1.8"
                fill="#C9D7FB"
              />
              <rect
                x="76.1504"
                y="81.75"
                width="18"
                height="3.6"
                rx="1.8"
                fill="#C9D7FB"
              />
            </g>
          </g>
          <g filter="url(#filter1_dd_5054_4642)">
            <rect
              x="141.851"
              y="25.0499"
              width="93.6"
              height="75.6"
              rx="1.8"
              fill="#DFE3E3"
            />
            <g clipPath="url(#clip2_5054_4642)">
              <rect
                x="139.151"
                y="22.35"
                width="93.6"
                height="75.6"
                rx="3.6"
                fill="white"
              />
              <path
                d="M139.151 25.95C139.151 23.9617 140.763 22.35 142.751 22.35H229.151C231.139 22.35 232.751 23.9618 232.751 25.95V30.45H139.151V25.95Z"
                fill="#EFF1F1"
              />
              <circle cx="144.551" cy="26.85" r="1.35" fill="#C9CDCD" />
              <circle cx="149.501" cy="26.85" r="1.35" fill="#C9CDCD" />
              <circle cx="154.451" cy="26.85" r="1.35" fill="#C9CDCD" />
              <rect
                x="148.151"
                y="42.15"
                width="23.4"
                height="45"
                rx="1.8"
                fill="#EAF0FF"
              />
              <rect
                x="176.951"
                y="43.95"
                width="46.8"
                height="3.6"
                rx="1.8"
                fill="#C9D7FB"
              />
              <rect
                x="176.951"
                y="51.15"
                width="36"
                height="3.6"
                rx="1.8"
                fill="#C9D7FB"
              />
              <rect
                x="176.951"
                y="60.15"
                width="46.8"
                height="12.6"
                rx="1.8"
                fill="#D9E4FB"
              />
              <rect
                x="176.951"
                y="78.15"
                width="32.4"
                height="3.6"
                rx="1.8"
                fill="#C9D7FB"
              />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_dd_5054_4642"
            x="15.5503"
            y="14.35"
            width="120.3"
            height="102.3"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5054_4642"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_5054_4642"
              result="effect2_dropShadow_5054_4642"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_5054_4642"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_dd_5054_4642"
            x="127.151"
            y="14.35"
            width="120.3"
            height="102.3"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5054_4642"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_5054_4642"
              result="effect2_dropShadow_5054_4642"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_5054_4642"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_5054_4642">
            <rect width="260" height="120" fill="white" />
          </clipPath>
          <clipPath id="clip1_5054_4642">
            <rect
              x="27.5503"
              y="22.35"
              width="93.6"
              height="75.6"
              rx="3.6"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip2_5054_4642">
            <rect
              x="139.151"
              y="22.35"
              width="93.6"
              height="75.6"
              rx="3.6"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
